import { render, staticRenderFns } from "./OrderFD.vue?vue&type=template&id=754bb1f6"
import script from "./OrderFD.vue?vue&type=script&lang=js"
export * from "./OrderFD.vue?vue&type=script&lang=js"
import style0 from "./OrderFD.vue?vue&type=style&index=0&id=754bb1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports